import { ICardInfo } from './cardInfo';
import { IThemeInfo } from './themeInfo';
import { ViewType } from '../../enums';

export * from './cardInfo';
export * from './themeInfo';

export interface ICardProps {
    info: ICardInfo;
    themeInfo: IThemeInfo;
    viewType: ViewType;

    onTeacherNameChanged?: (teacherName: string) => void;
    onCommentChanged?: (comment: string) => void;
}

export interface ICardStates {
    teacherName: string;
    comment: string;

    isTeacherNameEdit: boolean;
    isCommentEdit: boolean;
}
